/* eslint-disable no-unused-vars */
import SERVICE_CONSTANTS from '../../shared/_constants/services.constants';
import axios from 'axios';
import { serviceFactory } from '../../services/_helpers/serviceFactory';
import {
  COOKIESPOLICY_CMS_DATA,
  COOKIESPOLICY_TABLE_CMS_DATA,
  SHOW_LOADER,
} from './CookiesPolicyActionTypes';

export const setCookiesPolicyCMSData = (data) => {
  return {
    type: COOKIESPOLICY_CMS_DATA,
    payload: data,
  };
};

export const setCookiesPolicyTableCMSData = (data) => {
  return {
    type: COOKIESPOLICY_TABLE_CMS_DATA,
    payload: data,
  };
};

export function showLoader(isLoader) {
  return {
    type: SHOW_LOADER,
    isLoader,
  };
}

export const fetchCookiesPolicyCMSData = () => {
  return (dispatch) => {
    dispatch(showLoader(true));
    const appendUrl = SERVICE_CONSTANTS.cookiePolicyPage;
    const cookiesPolicyApi = `${process.env.REACT_APP_CDE_PORTALWEIR_API_BASEURL_GLOBAL}${appendUrl}`;
    axios
      .get(cookiesPolicyApi, {
        mode: 'no-cors',
        headers: {
          'Accept-Language': 'en',
        },
      })
      .then((response) => {
        dispatch(showLoader(false));
        dispatch(setCookiesPolicyCMSData(response.data));
      })
      .catch((err) => {
        dispatch(showLoader(false));
        serviceFactory.apiErrorHandle(err, dispatch);
        console.error('Error in cms api:', err);
      });
  };
};

export const fetchCookiesPolicyTableCMSData = () => {
  return (dispatch) => {
    dispatch(showLoader(true));
    const appendUrl = SERVICE_CONSTANTS.cookiePolicyTableContent;
    const cookiesPolicyTableApi = `${process.env.REACT_APP_CDE_PORTALWEIR_API_BASEURL_GLOBAL}${appendUrl}`;
    axios
      .get(cookiesPolicyTableApi, {
        mode: 'no-cors',
        headers: {
          'Accept-Language': 'en',
        },
      })
      .then((response) => {
        dispatch(showLoader(false));
        dispatch(setCookiesPolicyTableCMSData(response.data));
      })
      .catch((err) => {
        dispatch(showLoader(false));
        serviceFactory.apiErrorHandle(err, dispatch);
        console.error('Error in cms api:', err);
      });
  };
};
